/* eslint-disable */
import React, { useState } from 'react';
import { useNews } from '../context/NewsContext';
import {
  RiNewspaperLine,
  RiAddLine,
  RiEditLine,
  RiDeleteBinLine,
  RiEyeLine,
  RiCalendarLine,
  RiFileCopyLine,
  RiSearchLine,
  RiFilterLine,
  RiCloseLine,
  RiUploadLine,
  RiCheckLine,
  RiTimeLine,
} from 'react-icons/ri';
import './ManageNews.css';

const ManageNews = () => {
  const { news, featuredNews, stats, createNews, updateNews, deleteNews, togglePublish } = useNews();
  const [showModal, setShowModal] = useState(false);
  const [editingNews, setEditingNews] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterCategory, setFilterCategory] = useState('all');
  const [filterStatus, setFilterStatus] = useState('all');
  const [previewImage, setPreviewImage] = useState(null);
  
  const [formData, setFormData] = useState({
    title: '',
    content: '',
    summary: '',
    category: '',
    name: '',
    image: null,
    imageUrl: '',
    status: 'draft',
    featured: false,
    published_at: '',
    tags: []
  });

  const categories =[{ id: 1, name: 'Health'},
    { id: 2, name: 'Environment'},
    { id: 3, name: 'Women & Youth'},
    { id: 4, name: 'Peacebuilding'}
  ]

  const [tagInput, setTagInput] = useState('');
 
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const filteredNews = news.filter(item => {
    const matchesSearch = 
      item.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.summary?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.content?.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesCategory = filterCategory === 'all' || item.category === filterCategory;
    const matchesStatus = filterStatus === 'all' || item.status === filterStatus;
    
    return matchesSearch && matchesCategory && matchesStatus;
  });


    const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({
        ...prev,
        image: file,
        imageUrl: URL.createObjectURL(file),
        removeImage: false
      }));
    }
  };

  const addTag = () => {
    if (tagInput.trim() && !formData.tags.includes(tagInput.trim())) {
      setFormData(prev => ({
        ...prev,
        tags: [...prev.tags, tagInput.trim()]
      }));
      setTagInput('');
    }
  };

  const removeTag = (tagToRemove) => {
    setFormData(prev => ({
      ...prev,
      tags: prev.tags.filter(tag => tag !== tagToRemove)
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const newsData = new FormData();
    Object.keys(formData).forEach(key => {
      if (key === 'tags') {
        
        newsData.append(key, JSON.stringify(formData[key]));
      } else if (formData[key] !== null && formData[key] !== undefined) {
        newsData.append(key, formData[key]);
      }
    });

    let result;
    if (editingNews) {
      result = await updateNews(editingNews.id, newsData);
    } else {
      const payload = { ...formData };
      result = await createNews(payload);
    }

    if (result.success) {
      setShowModal(false);
      resetForm();
    }
  };

  const resetForm = () => {
    setFormData({
      title: '',
      content: '',
      summary: '',
      category: '',
      image: null,
      status: 'draft',
      featured: false,
      published_at: '',
      tags: []
    });
    setPreviewImage(null);
    setEditingNews(null);
    setTagInput('');
  };

  const handleEdit = (item) => {
    setEditingNews(item);
    setFormData({
      title: item.title || '',
      content: item.content || '',
      summary: item.summary || '',
      category: item.category || '',
      image: null,
      status: item.status || 'draft',
      featured: item.featured || false,
      published_at: item.published_at ? item.published_at.split('T')[0] : '',
      tags: item.tags || []
    });
    setPreviewImage(item.image_url);
    setShowModal(true);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

const getImageUrl = (imageUrl) => {
  if (!imageUrl) return '/assets/img/placeholder.png';
  if (imageUrl.startsWith('/uploads')) {
    if (process.env.NODE_ENV === 'development') {
      return `http://localhost:5000${imageUrl}`;
    }
    const apiUrl = 'https://brill.zuddo.biz/api';
    const backendOrigin = apiUrl.replace(/\/api\/?$/, '');
    return `${backendOrigin}${imageUrl}`;
  }
  if (imageUrl.startsWith('/assets/')) {
    return imageUrl;
  }
  return imageUrl;
};


  return (
    <div className="manage-news">
  
      <div className="news-header">
        <div className="header-left">
          <h1>News & Updates</h1>
          <p>Manage company news, events, and announcements</p>
        </div>
        <button className="btn-primary" onClick={() => setShowModal(true)}>
          <RiAddLine /> Create News
        </button>
      </div>

      <div className="news-stats">
        <div className="stat-card">
          <div className="stat-icon total">
            <RiNewspaperLine />
          </div>
          <div className="stat-content">
            <h3>{stats.total}</h3>
            <span>Total Posts</span>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon published">
            <RiCheckLine />
          </div>
          <div className="stat-content">
            <h3>{stats.published}</h3>
            <span>Published</span>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon drafts">
            <RiFileCopyLine />
          </div>
          <div className="stat-content">
            <h3>{stats.drafts}</h3>
            <span>Drafts</span>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon views">
            <RiEyeLine />
          </div>
          <div className="stat-content">
            <h3>{stats.views.toLocaleString()}</h3>
            <span>Total Views</span>
          </div>
        </div>
      </div>

      {featuredNews.length > 0 && (
        <div className="featured-news-section">
          <h2>Featured News</h2>
          <div className="featured-grid">
            {featuredNews.map(item => (
              <div key={item.id} className="featured-card">
                <div className="featured-image">
                  <img src={getImageUrl(item.image_url || item.imageUrl)} alt={item.title} />
                  <span className="featured-badge">Featured</span>
                </div>
                <div className="featured-content">
                  <h3>{item.title}</h3>
                  <p>{item.summary}</p>
                  <div className="featured-meta">
                    <span><RiCalendarLine /> {formatDate(item.published_at)}</span>
                    <span><RiEyeLine /> {item.views || 0} views</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}


      <div className="news-filters">
        <div className="search-box">
          <RiSearchLine />
          <input
            type="text"
            placeholder="Search news..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="filter-box">
          <RiFilterLine />
          <select value={filterCategory} onChange={(e) => setFilterCategory(e.target.value)}>
            <option value="all">All Categories</option>
            {categories.map(cat => (
              <option key={cat.id} value={cat.id}>{cat.name}</option>
            ))}
          </select>
        </div>
        <div className="filter-box">
          <select value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
            <option value="all">All Status</option>
            <option value="published">Published</option>
            <option value="draft">Draft</option>
          </select>
        </div>
      </div>

      <div className="news-grid">
        {filteredNews.map(item => (
          <div key={item.id} className="news-card">
            <div className="news-card-image">
              <img src={getImageUrl(item.image_url || item.imageUrl)} alt={item.title} />
              {item.featured && <span className="featured-tag">Featured</span>}
              <span className={`status-tag ${item.status}`}>{item.status}</span>
            </div>
            <div className="news-card-content">
              <div className="news-meta">
                <span className="category">{item.category_name || 'Uncategorized'}</span>
                <span className="date"><RiCalendarLine /> {formatDate(item.created_at)}</span>
              </div>
              <h3>{item.title}</h3>
              <p className="summary">{item.summary}</p>
              
              {/* Tags */}
              {item.tags && item.tags.length > 0 && (
                <div className="news-tags">
                  {item.tags.map((tag, idx) => (
                    <span key={idx} className="tag">#{tag}</span>
                  ))}
                </div>
              )}

    
              <div className="news-stats-row">
                <span><RiEyeLine /> {item.views || 0} views</span>
              </div>

          
              <div className="news-actions">
                <button className="btn-icon" onClick={() => handleEdit(item)} title="Edit">
                  <RiEditLine />
                </button>
                <button 
                  className="btn-icon" 
                  onClick={() => togglePublish(item.id)}
                  title={item.status === 'published' ? 'Unpublish' : 'Publish'}
                >
                  <RiCheckLine style={{ color: item.status === 'published' ? '#48bb78' : '#a0aec0' }} />
                </button>
                <button 
                  className="btn-icon delete" 
                  onClick={() => {
                    if (window.confirm('Delete this news item?')) {
                      deleteNews(item.id);
                    }
                  }}
                  title="Delete"
                >
                  <RiDeleteBinLine />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content large">
            <div className="modal-header">
              <h2>{editingNews ? 'Edit News' : 'Create New News'}</h2>
              <button className="modal-close" onClick={() => {
                setShowModal(false);
                resetForm();
              }}>
                <RiCloseLine />
              </button>
            </div>

            <form onSubmit={handleSubmit} className="news-form">
              <div className="form-grid">
                <div className="form-left">
                  <div className="form-group">
                    <label>Title *</label>
                    <input
                      type="text"
                      name="title"
                      value={formData.title}
                      onChange={handleInputChange}
                      placeholder="Enter news title"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Summary *</label>
                    <textarea
                      name="summary"
                      value={formData.summary}
                      onChange={handleInputChange}
                      placeholder="Brief summary (max 200 characters)"
                      rows="3"
                      required
                      maxLength="200"
                    />
                  </div>

                  <div className="form-group">
                    <label>Content *</label>
                    <textarea
                      name="content"
                      value={formData.content}
                      onChange={handleInputChange}
                      placeholder="Full news content..."
                      rows="8"
                      required
                    />
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label>Category</label>
                      <select name="category" value={formData.category} onChange={handleInputChange}>
                        <option value="">Select Category</option>
                        {categories.map(cat => (
                          <option key={cat.id} value={cat.id}>{cat.name}</option>
                        ))}
                      </select>
                    </div>

                    <div className="form-group">
                      <label>Publish Date</label>
                      <input
                        type="date"
                        name="published_at"
                        value={formData.published_at}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Tags</label>
                    <div className="tag-input-group">
                      <input
                        type="text"
                        value={tagInput}
                        onChange={(e) => setTagInput(e.target.value)}
                        placeholder="Add a tag and press Enter"
                        onKeyPress={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            addTag();
                          }
                        }}
                      />
                      <button type="button" onClick={addTag} className="btn-add-tag">Add</button>
                    </div>
                    <div className="tags-list">
                      {formData.tags.map((tag, idx) => (
                        <span key={idx} className="tag-item">
                          #{tag}
                          <button type="button" onClick={() => removeTag(tag)}>×</button>
                        </span>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="form-right">
                  <div className="form-group">
                    <label>Featured Image</label>
                    <div className="image-upload-area">
                      {previewImage ? (
                        <div className="image-preview">
                          <img src={previewImage} alt="Preview" />
                          <button 
                            type="button" 
                            className="remove-image"
                            onClick={() => {
                              setPreviewImage(null);
                              setFormData(prev => ({ ...prev, image: null }));
                            }}
                          >
                            <RiCloseLine />
                          </button>
                        </div>
                      ) : (
                        <label className="upload-placeholder">
                          <RiUploadLine />
                          <span>Click to upload image</span>
                          <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                            style={{ display: 'none' }}
                          />
                        </label>
                      )}
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="featured"
                        checked={formData.featured}
                        onChange={handleInputChange}
                      />
                      Feature this news
                    </label>
                  </div>

                  <div className="form-group">
                    <label>Status</label>
                    <select name="status" value={formData.status} onChange={handleInputChange}>
                      <option value="draft">Draft</option>
                      <option value="published">Published</option>
                    </select>
                  </div>

                  <div className="preview-info">
                    <h4>Preview</h4>
                    <div className="preview-stats">
                      <div><RiEyeLine /> Views: {editingNews?.views || 0}</div>
                      <div><RiTimeLine /> Created: {editingNews ? formatDate(editingNews.created_at) : 'New'}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-actions">
                <button type="button" className="btn-secondary" onClick={() => {
                  setShowModal(false);
                  resetForm();
                }}>
                  Cancel
                </button>
                <button type="submit" className="btn-primary">
                  {editingNews ? 'Update News' : 'Create News'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManageNews;